import React from "react";
import { Row, Col } from "antd";
import kids from "../imgs/kids.jpg";
// import girls from "../imgs/bjj_girls2.jpeg";
import girls from "../imgs/rga_girls.jpg";
import students from "../imgs/bjj.jpeg";
import regular from "../imgs/bjj2.jpeg";
import "./Prices.scss";

class Prices extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render()
  {
    return (
      <React.Fragment>
        <br />
        <h1 className="heading">Prices</h1>
        <Row gutter={10}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Kinder & Schüler</h3>
              </div>
              <div className="panel-body">
                <div className="price">&euro; 45.00</div>
                <div className="sub-price">Pro monat*</div>
                <div
                  className="image"
                  style={{ backgroundImage: `url(${ kids })` }}
                />
                <div className="payments">
                  12 Monate <strong>45,- / Monat</strong> 
                  {/* oder{" "} <strong>400,- Einmalig</strong> */}
                </div>
                <div className="payments">
                  6 Monate <strong>55,- / Monat</strong> 
                  {/* {" "} <strong>250,- Einmalig</strong> */}
                </div>
                {/*
                <div className="payments">
                  3 Monate <strong>45,- / Monat</strong>
                </div>
                */}
                <br />
                <div className="conditions">
                  Gilt bis zum Vollendeten 16. Lebenjahr
                </div>
                <div className="conditions">* Bei 12 Monate bindung</div>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Studenten</h3>
              </div>
              <div className="panel-body">
                <div className="price">&euro; 90.00</div>
                <div className="sub-price">Pro monat*</div>
                <div
                  className="image"
                  style={{ backgroundImage: `url(${ students })` }}
                />
                <div className="payments">
                  12 Monate <strong>90,- / Monat</strong> oder{" "}
                  <strong>800,- Einmalig</strong>
                </div>
                <div className="payments">
                  6 Monate <strong>100,- / Monat</strong> oder{" "}
                  <strong>550,- Einmalig</strong>
                </div>
                {/*
                <div className="payments">
                  3 Monate <strong>72,- / Monat</strong>
                </div>
                */}
                <br />
                <div className="conditions">
                  Gilt bis zum Vollendeten 27. Lebenjahr
                </div>
                <div className="conditions">* Bei 12 Monate bindung</div>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Frauen</h3>
              </div>
              <div className="panel-body">
                <div className="price">&euro; 60.00</div>
                <div className="sub-price">Pro monat*</div>
                <div
                  className="image"
                  style={{ backgroundImage: `url(${ girls })` }}
                />
                <div className="payments">
                  12 Monate <strong>60,- / Monat</strong> oder{" "}
                  <strong>600,- Einmalig</strong>
                </div>
                <div className="payments">
                  6 Monate <strong>65,- / Monat</strong> oder{" "}
                  <strong>350,- Einmalig</strong>
                </div>
                {/*
                <div className="payments">
                  3 Monate <strong>60,- / Monat</strong>
                </div>
                */}
                <br />
                <div className="conditions">* Bei 12 Monate bindung</div>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Regular</h3>
              </div>
              <div className="panel-body">
                <div className="price">&euro; 100.00</div>
                <div className="sub-price">Pro monat*</div>
                <div
                  className="image"
                  style={{ backgroundImage: `url(${ regular })` }}
                />
                <div className="payments">
                  12 Monate <strong>100,- / Monat</strong> oder{" "}
                  <strong>950,- Einmalig</strong>
                </div>
                <div className="payments">
                  6 Monate <strong>110,- / Monat</strong> oder{" "}
                  <strong>600,- Einmalig</strong>
                </div>
                {/*
                <div className="payments">
                  3 Monate <strong>85,- / Monat</strong>
                </div>
                */}
                <br />
                <div className="conditions">* Bei 12 Monate bindung</div>
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default Prices;
